document.addEventListener('DOMContentLoaded', function () {
  const html = document.documentElement;
  const giftbox = document.querySelector('#giftbox');
  const modal = document.querySelector('#giftbox-popup');
  const listGiftbox = giftbox.querySelector('.list-giftbox');
  
  const form = document.querySelector('#product-info-group form[action="/cart/add"]');
  const appBlockCc = form?.querySelector('click-and-collect');
  const pickupMethod = document.querySelector('#product-info-group .cc__delivery_method.cc__delivery_method--pickup-store');
  const btnATC = document.querySelector('#product-info-group .cc__submit-group');
  const btnATCSticky = document.querySelector('#product-info-group .cc__sticky-cta.cc__sticky-cta--show');
  const btnSelectStore = document.querySelector('#product-info-group .cc-payment-button.select_store-button');
  const pickupStore = pickupMethod?.querySelector('#pickup_in_store');
  const checkboxes = giftbox.querySelectorAll('input.select-gift');

  if (giftbox) {
    const maxGiftbox = parseInt(giftbox.dataset.max_giftbox);
    const bundleListId = giftbox.querySelector('input[name="properties[_bundle_list]"]');

    const resetGiftbox = () => {
      checkboxes.forEach(cb => {
        cb.checked = false;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    const updateCheckboxState = () => {
      const checkedGift = [...checkboxes].filter(cb => cb.checked);

      checkboxes.forEach(cb => {
        const gridItem = cb.closest('.gift-item');
        const shouldDisable = (checkedGift.length >= maxGiftbox && !cb.checked) || gridItem.classList.contains('out-stock');
        cb.disabled = shouldDisable;
        gridItem.classList.toggle('disabled', shouldDisable);
      });

      if (checkedGift.length > 0) {
        if (pickupStore?.checked) {
          btnSelectStore?.classList.add('events-none');
          btnATC?.classList.add('events-none');
          btnATCSticky?.classList.add('hidden');
        }

        // Add child
        bundleListId.disabled = false;
        const variantIds = checkedGift.map(cb => cb.dataset.variant_id);
        bundleListId.value = variantIds.join(',');

        // Validate pickup-store
        pickupMethod?.classList.add('disabled-pickup-store');
      } else {
        // Remove child
        bundleListId.disabled = true;
        bundleListId.value = "";

        // Validate pickup-store
        pickupMethod?.classList.remove('disabled-pickup-store');
        btnSelectStore?.classList.remove('events-none');
        btnATC?.classList.remove('events-none');
        btnATCSticky?.classList.remove('hidden');
      }
    };
    window.addEventListener('pageshow', function () {
      reloadGiftbox();
    });
    checkboxes.forEach(cb => {
      cb.addEventListener('change', updateCheckboxState);
    });

    document.addEventListener('variant:change', function (e) {
      // Reset giftbox
      resetGiftbox();
    });

    const reloadGiftbox = async function () {
      resetGiftbox();
      listGiftbox.classList.add('loading-spinner');
  
      const cartRes = await fetch('/cart.js');
      currentCart = await cartRes.json();
  
      for (const cb of checkboxes) {
        const currentQtyAvailable = await window.XD.getVariantQuantityAvailable(cb.dataset.variant_id);
        const currentQty = window.XD.getVariantQuantity(currentCart, cb.dataset.variant_id);
        const maxQty = currentQtyAvailable - currentQty;
      
        if (maxQty < 1) {
          const gridItem = cb.closest('.gift-item');
          cb.disabled = true;
          gridItem.classList.add('out-stock');
          gridItem.classList.toggle('disabled', true);
        }
      }
  
      listGiftbox.classList.remove('loading-spinner');
    }
    
    document.addEventListener('ajaxProduct:added', function (e) {
      reloadGiftbox();
    });
    document.addEventListener('ajaxProduct:error', function (e) {
      reloadGiftbox();
    });
    document.addEventListener('cart:updated', function (e) {
      reloadGiftbox();
    });
    
  }

  if (modal) {
    const openModal = () => {
      modal.classList.add('modal--is-active');
      html.classList.add('modal-open');
    };
    const closeModal = () => {
      modal.classList.remove('modal--is-active');
      html.classList.remove('modal-open');
    };

    const atcOpenModal = document.querySelector('button[data-popup="giftbox-popup"]');
    if (atcOpenModal) {
      atcOpenModal.addEventListener('click', openModal);
    }
    modal.querySelector('.close-modal')?.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      const content = modal.querySelector('.giftbox-popup-content');
      if (!content.contains(e.target)) {
        closeModal();
      }
    });
    modal.querySelectorAll('.grid-product').forEach(item => {
      item.addEventListener('click', () => {
        closeModal();
      });
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('form .shopify-payment-button');
    const btnSticky = e.target.closest('form .cc__sticky-btn-primary');
    if (!btn && !btnSticky) return;

    const checkedGift = [...checkboxes].filter(cb => cb.checked);
    const btnAddToCart = document.querySelector('#add_to_cart');

    if (btnAddToCart && checkedGift.length > 0) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      btnAddToCart.click();
      window.redirectToCart = true;
    }
  },
  true);
});